// extracted by mini-css-extract-plugin
module.exports = {"tab":"toptab_tab__d_KJs"};